import React from "react";
import { useForm } from "react-hook-form";
import { useState } from "react";
import {
  AUTO_PAY_AMOUNT_CHANGED,
  AUTO_PAY_METHOD_CHANGED,
} from "app/context/bill-details/Actions";
import { StoreContext } from "app/context/Store";
import Select from "react-select";

function EnableAutoPay() {
  const context = React.useContext(StoreContext);
  const { register, handleSubmit, setValue } = useForm();
  const autoPayData = context?.billState?.autoPayDetails;
  setValue("maxLimit", autoPayData?.maxLimitAmount);
  setValue("paymentMode", autoPayData?.preferredPaymentMode);
  const optionsList = [
    { value: "Credit Card", label: "Credit Card" },
    { value: "Debit Card", label: "Debit Card" },
    { value: "Net Banking", label: "Net Banking" },
  ];

  const [selectedValue, setSelectedValue] = useState(optionsList[0]);

  return (
    <div className="row">
      <form onSubmit={handleSubmit(() => {})}>
        <div className="col-md-12 custom-50">
          <p className="pb-2">
            Choosing Auto pay option will automatically pay the bill on every
            due date
          </p>
          <div className="form-group">
            <input
              // disabled = {!context?.state?.isEditing}
              type="number"
              {...register("maxLimit")}
              className="form-control"
              placeholder="Max Limit"
              onChange={(event) => {
                context.dispatchBillState({
                  type: AUTO_PAY_AMOUNT_CHANGED,
                  payload: event.target.value,
                });
              }}
            />
          </div>
          <p className="pb-2">
            Auto pay for bill amount greather then max limit will fail
          </p>
        </div>
        <div className="col-md-12 custom-50">
          <div className="form-group select-custom">
            <i className="material-icons">expand_more</i>
             <Select
                options={optionsList}
                value={selectedValue}
                onChange={(option) => {
                  context.dispatchBillState({
                    type: AUTO_PAY_METHOD_CHANGED,
                    payload: option.value,
                  });
                  setSelectedValue(option);
                }}
              />
          </div>
        </div>
        {/* <div className="my-2">
        <Button className="button btn-primary mb-4"> Confirm </Button>
        <Button className="button btn-primary-outline"> Cancel </Button>
      </div> */}
      </form>
    </div>
  );
}

export default EnableAutoPay;
